import React, { useCallback, useEffect, useState } from 'react'
import classNames from 'classnames'
import _ from 'lodash'
import {
  useI18n,
  useRehabQuestion1,
  useRehabSelectedThemes,
  useUhOhStatus,
} from 'contexts/AuthContext'
import CareSelectButton from 'components/CareSelectButton/index'
import ContentHeader from 'views/Care/ContentHeader'
import classes from './index.module.scss'
import { ScreenKey } from 'views/Care/util'
import { logAmplitudeEvent } from 'utils/amplitudeInit'
import { getThemesByProgramIdPromise } from 'apis/FitOnCareAPI'
import { getLocalLanguage } from 'utils/authLocalStorage'
import { UhOhStatus } from 'views/Care/UhOh'
const { styles } = classes

const formatThemeNames = (themes, i18n) => {
  if (_.isEmpty(themes)) return ''
  if (themes.length === 1) return _.first(themes)
  if (themes.length === 2) return _.join(themes, `  ${i18n('and')} `)
  return `${_.join(_.initial(themes), ', ')} ${i18n('and')} ${_.last(themes)}`
}

const question1Options = [
  {
    id: 0,
    name: 'Yes',
  },
  {
    id: 1,
    name: 'No',
  },
]

const RehabQuestion1 = (props) => {
  const { sku, programId, fitonUserId, theme } = props
  const { i18n } = useI18n()
  const { setRehabQuestion1, rehabQuestion1 } = useRehabQuestion1()
  const { rehabSelectedThemes } = useRehabSelectedThemes()
  const { setUhOhStatus } = useUhOhStatus()
  const [themeNames, setThemeNames] = useState(null)

  const getThemes = useCallback(async () => {
    if (fitonUserId && programId) {
      const resp = await getThemesByProgramIdPromise({
        userId: fitonUserId,
        programId,
      })
      setThemeNames(
        formatThemeNames(
          resp?.themes?.map((theme) => theme.name),
          i18n
        ) ||
          formatThemeNames(
            rehabSelectedThemes?.map((theme) => theme.name),
            i18n
          ) ||
          theme ||
          ''
      )
    } else {
      setThemeNames(
        formatThemeNames(
          rehabSelectedThemes?.map((theme) => theme.name),
          i18n
        ) ||
          theme ||
          ''
      )
    }
  }, [fitonUserId, programId, rehabSelectedThemes, theme])

  useEffect(() => {
    getThemes()
  }, [getThemes])

  useEffect(() => {
    if (themeNames !== null) {
      logAmplitudeEvent('Screen View: Onboarding - Recent Pain', {
        sku,
        theme: themeNames.replace(' and ', ', '),
        language: getLocalLanguage(),
      })
    }
  }, [sku, themeNames])

  const onSubmit = async (item) => {
    logAmplitudeEvent('Click: Onboarding - Recent Pain', {
      sku,
      theme: themeNames.replace(' and ', ', '),
      language: getLocalLanguage(),
      recent_pain: item.name,
    })
    setRehabQuestion1(item)
    if (item.id === 0) {
      props.setCurrentKey(ScreenKey.REHAB_QUESTION_2)
    } else {
      setUhOhStatus(UhOhStatus.QUESTION_1)
      props.setCurrentKey(ScreenKey.UH_OH)
    }
  }

  return (
    <div className={classNames(styles, 'info-sec')}>
      <ContentHeader {...props} />
      <div className='info-content'>
        <div className='title'>{i18n(`Let's check on your pain level`)}</div>
        <div className='subtitle'>
          {i18n(
            `Have you experienced persistent pain, stiffness, or discomfort in your {0}, in the last two weeks?`,
            themeNames
          )}
        </div>
        {question1Options.map((item, index) => (
          <CareSelectButton
            key={index}
            {...{
              selected: rehabQuestion1?.id === item.id,
              setSelected: () => {
                onSubmit({ ...item })
              },
              text: i18n(item.name),
              className: 'm-b-12 button',
            }}
          />
        ))}
      </div>
    </div>
  )
}

export default RehabQuestion1
